$('.accord1 li .accord-label').click(function () {
	$(this).next(".accord-content").slideToggle();
	$(this).closest("li").siblings().find('.accord-content').slideUp();

	$(this).parent().addClass("active-month");
	$(this).parent().siblings().removeClass("active-month")

	const itemId = "[href='#" + $(this).parent().attr('id') + "']";

	$('.annual-year-block .links .active-month').removeClass("active-month");
	$(itemId).addClass("active-month");
});

$('.annual-year-block .links a').click(function () {
	$('.annual-year-block .links .active-month').removeClass("active-month");
	$(this).addClass("active-month");

	const itemId = $(this).attr('href');
	const item = $(itemId);

	$(item).find(".accord-label").next(".accord-content").slideToggle();
	$(item).find(".accord-label").closest("li").siblings().find('.accord-content').slideUp();

	$(item).addClass("active-month");
	$(item).siblings().removeClass("active-month")
});